<template>
  <div>
    <div class="page-content">
      <div class="container">
        <h2 class="content-heading">Recharge Device</h2>
        <div class="main-container">
            <form-wizard color="#269af1"  step-size="sm"  @on-complete="finishGeneration">
                <h2 slot="title"></h2>
                <tab-content title="Device ID" icon="fa fa-building-o" :before-change="checkValidation">
                    <b-modal centered  ref="myModalRef" hide-footer title="PIN Number">
                      <div class="d-block text-center">
                        <p>{{ myResponse }}</p>
                      </div>
                      <b-btn class="mt-3 ok" variant="outline-danger" block @click="hideModal">Close Me</b-btn>
                    </b-modal>
                <div class="main-container">
                      <div class="row">
                        <div class="col-12">
                          <!-- <div class="form-group"> -->
                            <label for="inverter-number">Inverter Number</label>
                      <v-autocomplete :items="items" 
                      placeholder="Please Enter Inverter Number" 
                      required v-model="formData.item" :get-label="getLabel" 
                      :component-item='template' @update-items="updateItems">
                        </v-autocomplete>
                        </div>
                      </div>
                      </div>
                </tab-content>
                <tab-content title="Duration Info"
                            icon="iconfont iconfont-clock" :before-change="concludeTransaction">
                  <div class="row" v-show="carddetail==false">
                    <div class="col-12">
                      <div class="heading" style="text-align: center;">
                <h5>Note that the token will be send to the details below:
                  <!-- {{formData.item}} -->
                  <br /><b v-if="formData.item !==null">Name: {{formData.item.name}}</b> 
                  <br /><b v-if="formData.item !==null">Email: {{formData.item.user.email}}</b> 
                  <br /><b v-if="formData.item !==null">Phone Number: {{formData.item.user.phoneNumber}}</b> 
                  </h5>
             </div>


                      <div class="form-group">
                        <label for="duration">Duration</label>
                        <b-form-select v-model="formData.duration" :options="options" class="mb-3 form-control form-control-lg" />
                      </div>
                    </div>
                  </div>
                   <div v-show="(formData.duration*initAmt>getUserSession.wallet)" title="Payment" icon="iconfont iconfont-widget-money">
                  <div class="row">
 <div class="col-12" style="background:#ffffff">
      <div class="container-fluid">
        <div class="wallet">
            <div class="payment" v-show="carddetail==false">
            <div class="heading">
                <h1>Make Payment</h1>
                <h4  style="text-align: center;">To complete this transaction additional payment of 
                  {{(initAmt * formData.duration) - getUserSession.wallet}}
                  has to be made or fund you wallet direct here
                  <b-btn :variant="`info`" size="sm" @click="paymentFormSelected = `wallet funding`" to="/shs/pay?type=wallet">
              Fund Wallet
            </b-btn>
                  </h4>
             </div>
                       <div class="form-group cardno" id="cardno-field">
                        <label for="cardNumber">Card Number</label>
                        <b-form-input type="text"  placeholder="XXXX XXXX XXXX XXXX" v-model="formData.cardno" @input="cardValidate" class="form-control form-control-lg" id="ccnum"/>
                    </div>
                    <div class="form-group owner">
                        <label for="owner">Card Name</label>
                        <b-form-input type="text"  v-model="formData.name" placeholder="John Doe" class="form-control form-control-lg" />
                    </div>
                     <div class="form-group CVV">
                        <label for="cvv">CVV</label>
                        <b-form-input type="text"  v-model="formData.cvv" placeholder="123" class="form-control form-control-lg" id="cvc"/>
                    </div>
                     <div class="form-group CVV">
                        <label for="pin">PIN</label>
                        <b-form-input type="text"  v-model="formData.pin" class="form-control form-control-lg" placeholder="XXXX" id="pin"/>
                    </div>
                     
                    <div class="form-group expiration-date">
                        <label for="expiry">Expire Date</label>
                        <b-form-input type="text"  v-model="formData.expiry" class="form-control form-control-lg" placeholder="12 / 21" id="expiry"/>
                    </div>
                   <div class="form-group owner" id="owner">
                        <label for="email">Email</label>
                        <b-form-input type="email"  v-model="formData.email" class="form-control form-control-lg" placeholder="mymail@mail.com" id="email"/>
                    </div>
                    <div class="form-group cardno">
                        <label for="mobile">Phone No</label>
                        <b-form-input type="tel"  v-model="formData.phonenumber" class="form-control form-control-lg cc-number" placeholder="08011111111" id="mobile"/>
                    </div>
        
                   
                    <div style="clear:both"></div>
                   <div class="form-group">
                        <button type="button" class="btn btn-default" @click="confirmPayment">Confirm</button>
                    </div>
                     <div class="form-group cardtype">
                        <img src="../../../assets/img/visa.jpg" id="visa" class="transparent">
                        <img src="../../../assets/img/mastercard.jpg" id="mastercard" class="transparent">
                        <img src="../../../assets/img/amex.jpg" id="amex" class="transparent">
                    </div>
            </div>
            <div class="payment2" v-show="carddetail==true" >
             <div class="form-group">
                          <div class="d-block text-center">
                      <p>Your Transaction Reference is 
                        <b>{{ transactionReference }}</b> 
                        please supply the otp sent to your mobile to complete the Transaction</p>
                        </div>
                        <b-form-input type="text"  v-model="otp" class="form-control form-control-lg" placeholder="please supply otp" id="otp"/>
                    </div>
              </div>
        </div>
    </div>
  </div> 
  </div> 
                  
                </div>
                </tab-content>
                <tab-content title="Transaction Status"
                                icon="fa fa-ticket">
                    <div class="widget_box" v-show="tokenGenerated === true">
                      <figcaption>
                        <i class="fa fa-money"></i>
                       <h2>Successful</h2>
                      <b v-if="transactionReference !==null "> Wallet transaction Reference is: {{transactionReference}}</b>
                        <h3>solar Kit Id: <b>{{ (myResponse !== null) ? myResponse.solarKitId:'-' }}</b> </h3>
                        <h3>No of Days: <b>{{ (myResponse !== null) ?formData.duration:'-' }}</b> </h3>
                        <h3 v-if="myResponse.token !== null">Token Generated: {{(myResponse !== null) ? numberWithSpaces(myResponse.token) : '-'}}</h3>
                        <h3 v-if="myResponse.token === null">Expiry Date: {{(myResponse !== null)? myResponse.expiry : '-'}}</h3>
                      </figcaption>
                    </div>
                    <div class="widget_box" v-show="tokenGenerated === false">
                      <figcaption>
                        Transaction in Progress ... 
                      </figcaption>
                      <h6>Note: If your wallet balance is lesser than your transaction, Please make payment before you proceed
                        <b-btn :variant="`info`" size="sm" @click="paymentFormSelected = `wallet funding`" to="/shs/pay?type=wallet">
              Fund Wallet
            </b-btn>
                      </h6>
                    </div>
                </tab-content>
            </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
/* eslint-disable */

import Vue from "vue";
import Autocomplete from "v-autocomplete";
import ItemTemplate from "../../utils/ItemTemplate.vue";
import Fingerprint2 from "fingerprintjs2";
import payform from "payform";
Vue.use(Autocomplete);
import { mapGetters } from "vuex";
export default {
  name: "generate-token",
  components: {},
  data() {
    return {
      deviceVerified: false,
      tokenGenerated: false,
      carddetail: false,
      initAmt: 0.0,
      reciever: {
        name: null,
        phone: null,
        email: null
      },
      formData: {
        item: null,
        duration: 0,
        cardno: null,
        cvv: null,
        expiry: null,
        expirymonth: "00",
        expiryyear: "00",
        pin: null,
        email: null,
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 0.0,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      otp: "",
      transactionReference: null,
      currentDevice: null,
      subscriptionPlan: null,
      myResponse: {token:null,expiry:null},
      options: [
        { value: null, text: "Please select an option", disabled: true },
        { value: 3, text: "3 days" },
        { value: 7, text: "7 days" },
        { value: 15, text: "15 days" },
        { value: 30, text: "30 days" }
      ],
      countries: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "NG", text: "Nigeria" }
      ],
      currency: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "NGN", text: "Naria" }
      ],
      items: [],
      errors: null,
      template: ItemTemplate
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    // validateFormData() {
    //   confirm
    //   if(this.tokenGenerated==true){
    //     console.log('me 1')
    //     return true;
    //   }else if (
    //     this.formData.duration == null ||
    //     this.formData.item.solarKitIds === null
    //   ) {
    //     let errTemp = "Please fill all required fields.";
    //     this.showErrorMsg({ message: errTemp });
    //      console.log('me 2')
    //     return false;
    //   } else if (
    //     this.formData.duration * this.initAmt <=
    //     this.getUserSession.wallet
    //   ) {
    //      console.log('me 3')
    //     return this.generateToken(this.formData);
    //   } else if (this.carddetail === true) {
    //     this.concludeTransaction();
    //   } else {
    //      console.log('me 4')
    //     if (
    //       this.formData.duration * this.initAmt >
    //       this.getUserSession.wallet
    //     ) {
    //        console.log('me 5')
    //       this.confirmPayment();
    //     }
    //   }
    // },
    generateToken(data) {
      const HTTP = this.$httpUtils.instance;
      const param = { solarKitId: data.item.solarKitIds, value: data.duration };
      let str = JSON.stringify(param);
      const tempReg = JSON.parse(str);
      const url = "/tokens/webAPI/";
      let element = document.getElementsByClassName("wizard-nav-pills");
      HTTP.post(url, tempReg)
        .then(response => {
          this.tokenGenerated = true;
          let d = new Date();
          let expiry=new Date(d.setDate(d.getDate() + data.duration)).toDateString()
          this.myResponse = response.data.solarKitId !==undefined ? response.data : {solarKitId:data.item.solarKitIds,token:null,expiry};
          // element.classList.add('set-disabled')
          return true;
        })
        .catch(error => {
          console.log("error", error);
          this.showErrorMsg({
            message: JSON.stringify(error.response.data.error.message)
          });
         this.tokenGenerated = false; 
         return false
        });
        // element.classList.add('set-disabled')
        return true;
    },
    concludeTransaction() {
      const b =
        this.getUserSession.wallet-(this.initAmt * this.formData.duration);
      if (b >= 0) { 
          return this.generateToken(this.formData)
      }

      let formParam = {
        transactionReference: this.transactionReference,
        otp: this.otp
      };
      var data = true;
      if (this.carddetail == false) {
        this.confirmPayment();
        return false;
      }
      this.validateReg(formParam);
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        this.showErrorMsg({ message: errorMsg });
        return false;
      } else {
        var str = JSON.stringify(formParam);
        const tempReg = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const url = "/payments/raveCardValidate/";
        HTTP.post(url, tempReg)
          .then(response => {
            data = this.generateToken(this.formData);
          })
          .catch(error => {
            console.log(error);
            // var errorMsg = error.response.message;
             this.showErrorMsg({ message: "Transaction not successful" });
            return false;
          });
      }
      return data;
    },
    confirmPayment() {
      this.validateReg(this.formData);
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        this.showErrorMsg({ message: errorMsg });
      } else {
        [
          container.formData.expirymonth,
          container.formData.expiryyear
        ] = container.formData.expiry.split(" / ");
        [
          container.formData.firstname,
          container.formData.lastname
        ] = container.formData.name.split(" ");
        container.formData.deviceFingerprint =
          container.formData.device_fingerprint.result;
        container.formData.cardno = container.formData.cardno.replace(
          new RegExp(" ", "g"),
          ""
        );
        container.formData.amount = `${container.initAmt *
          container.formData.duration -
          this.getUserSession.wallet}`;
        var str = JSON.stringify(container.formData);
        const tempReg = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const url = "/payments/raveCardCharge/";
        HTTP.post(url, tempReg)
          .then(response => {
            this.transactionReference = response.data;
            this.carddetail = true;
          })
          .catch(error => {
            var messages = error.message;
            this.showErrorMsg({ message: messages });
          });
      }
    },
    finishGeneration() {
      this.$router.push({ path: "/home" });
    },
    checkValidation() {
      if (this.deviceVerified === false) {
        alert("Please verify device.");
        return false;
      } else {
        this.updateSubType();
        var fp = Fingerprint2();
        fp.get((result, components) => {
          this.formData.device_fingerprint.result = result; // a hash, representing your device fingerprint
          this.formData.device_fingerprint.components = components; // an array of FP components
          console.log(this.formData.device_fingerprint)
        });
        this.deviceVerified == true;
        return true;
      }
    },
    updateSubType() {
      console.log(this.formData.item.deviceType.id)
      let name = this.subscriptionPlan.filter(x=>{
        return x.deviceTypeId == this.formData.item.deviceType.id
      });
      this.initAmt = name[0].amount / name[0].value;
    },
    validateReg(data) {
      let err = [];
      for (let [field, value] of Object.entries(data)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        if (value === "null" || value === "") {
          err[field] = `Please select a ${field}.`;
        } else if (field == "email" && !this.isEmail(value)) {
          err[field] = "Not a valid email.";
        }
      }
      this.errors = err;
      // console.log(this.errors);
    },
    cardValidate() {
      let cardNumber = document.getElementById("ccnum");
      let cardNumberField = document.getElementById("cardno-field");
      let mastercard = document.getElementById("mastercard");
      let visa = document.getElementById("visa");
      let amex = document.getElementById("amex");

      amex.classList.add("transparent");
      visa.classList.add("transparent");
      mastercard.classList.add("transparent");

      if (payform.validateCardNumber(cardNumber.value) == false) {
        cardNumberField.classList.add("has-error");
      } else {
        cardNumberField.classList.remove("has-error");
        cardNumberField.classList.add("has-success");
      }
      const b = payform.parseCardType(cardNumber.value);
      document.getElementById(b).classList.remove("transparent");
    },
    getLabel(item) {
      this.deviceVerified = true;
      return item.solarKitIds;
    },
    returnData(data, int = 0) {
      let rData = [];
      for (var value of this.currentDevice) {
        if (
          (value.name.toLowerCase().indexOf(data.toLowerCase()) > -1 ||
            value.solarKitIds.indexOf(data) > -1 ||
            value.userId === data) &&
          int == 0
        ) {
          rData.push(value);
        } else if (value.userId == data && int == 1) {
          document.getElementsByClassName("v-autocomplete-input").value =
            value.solarKitIds;
          rData.push(value);
        }
      }
      // this.formData.amount=this.subscriptionPlan
      return rData;
    },
    find_prop(obj, key) {
      return (() => {
        const keyNest = key.split(".");
        if (this.currentDevice === null || obj === undefined) {
          return "-";
        } else if (keyNest.length > 1) {
          return this.find_prop(obj[keyNest.shift()], keyNest.join("."));
        } else {
          return obj[key];
        }
      })();
    },
    device_prop(key) {
      return this.find_prop(this.currentDevice, key);
    },

    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    updateItems(text, int) {
      this.items = this.returnData(text, int);
    },
    loader(int = 0) {
      const context = this;
      const HTTP = this.$httpUtils.instance;
      var inverterId = this.formData.inverter_number;
      let url = `/installations/?filter={"where":{"status":"completed"},"include":["deviceType","user"]}`;
      if (this.$can("manage", "mine")) {
        url = `/installations/?filter={"where":{"status":"completed","userId":${
          this.getUserSession.id
        }},"include":["deviceType","user"]}`;
      }

      HTTP.get(url).then(response => {
        this.currentDevice = response.data;
        this.updateItems(`${this.getUserSession.id}`, int);
      });
      this.formData.name = `${this.getUserSession.firstName} ${
        this.getUserSession.lastName
      }`;
      this.formData.phonenumber = `${this.getUserSession.phoneNumber}`;
      this.formData.email = `${this.getUserSession.email}`;

      payform.cardNumberInput(document.getElementById("ccnum"));
      payform.expiryInput(document.getElementById("expiry"));
      payform.cvcInput(document.getElementById("cvc"));
      payform.numericInput(document.getElementById("mobile"));
      payform.numericInput(document.getElementById("pin"));
    },
    getSubscriptionPlan() {
      const HTTP = this.$httpUtils.instance;
      let url = `/subscription_plans/`;
      HTTP.get(url).then(response => {
        this.subscriptionPlan = response.data;
      });
      this.loader(1);
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    showModal() {
      this.$refs.myModalRef.show();
    }
  },
  mounted() {
    if (!this.$can("create", "token")) {
      this.$router.push({ path: "/" });
      return;
    }
    this.getSubscriptionPlan();
  },
  computed: {
    ...mapGetters(["getUserSession"])
  }
};
</script>
<style>
/* a {
  color: white !important;
} */
.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
  width: 100%;
}

.v-autocomplete-selected .v-autocomplete-input {
  color: green;
  background-color: #f2fff2;
}

.v-autocomplete-list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #157977;
}

.v-autocomplete-list-item {
  cursor: pointer;
  background-color: #fff;
  padding: 5px;
  border-bottom: 1px solid #157977;
  border-left: 1px solid #157977;
  border-right: 1px solid #157977;
}

.v-autocomplete-list-item:last-child {
  border-bottom: none;
}

.v-autocomplete-list-item:hover {
  background-color: #eee;
}

abbr {
  opacity: 0.8;
  font-size: 0.8em;
  display: block;
  font-family: sans-serif;
}

pre {
  text-align: left;
  white-space: pre-wrap;
  background-color: #eee;
  border: 1px solid silver;
  padding: 10px !important;
  border-radius: 10px;
  font-family: monospace !important;
}
.note {
  border-left: 5px solid #ccc;
  padding: 10px;
}
.left {
  text-align: left;
}
</style>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font: normal 18px sans-serif;
  color: #333;
  background-color: #eee;
}

.container-fluid {
  padding: 0;
  margin: 0;
}

.wallet {
  max-width: 700px;
  background-color: #fff;
  margin: 10px auto;
  overflow: hidden;
  padding: 25px;
  color: #4c4e56;
}

.wallet label {
  width: 100%;
  margin-bottom: 10px;
}

.wallet .heading h1,
.wallet .heading h5 {
  text-align: center;
  font-family: "Open Sans", sans-serif;
  color: #4c4e56;
}

.wallet .payment {
  float: left;
  font-size: 18px;
  padding: 10px 25px;
  margin-top: 20px;
  position: relative;
}

.wallet .payment .form-group {
  float: left;
  margin-bottom: 15px;
}

.form-control {
  line-height: 40px;
  height: auto;
  padding: 0 16px;
}

.wallet .owner {
  width: 53.5%;
  margin-right: 10px;
}

.wallet .CVV {
  width: 30%;
  margin-right: 10px;
}

.wallet #card-number-field {
  width: 100%;
}

.wallet .expiration-date {
  width: 34%;
}

.wallet .cardno {
  width: 42%;
  margin-right: 10px;
}

.wallet #pay-now {
  width: 100%;
  margin-top: 25px;
}

.wallet .payment .btn-default {
  width: 100%;
  margin-top: 3px;
  font-size: 24px;
  background-color: #2ec4a5;
  color: white;
}

.wallet .payment select {
  padding: 10px;
  margin-right: 15px;
}
.wallet .payment .cardtype {
  float: right;
}
.transparent {
  opacity: 0.2;
}
.set-disabled {
    opacity: .5;
    pointer-events: none;
}
@media (max-width: 650px) {
  .wallet .owner,
  .wallet .CVV,
  .wallet #expiration-date,
  .wallet #credit_cards {
    width: 100%;
  }
  .wallet #credit_cards {
    text-align: left;
  }
}
</style>

















// WEBPACK FOOTER //
// src/components/pages/shs/GenerateToken.vue